import { render, staticRenderFns } from "./HorizontalInfoCard.vue?vue&type=template&id=2c06ca5c&scoped=true&"
import script from "./HorizontalInfoCard.vue?vue&type=script&lang=js&"
export * from "./HorizontalInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06ca5c",
  null
  
)

export default component.exports